module.exports = __webpack_public_path__ + "img/04.33ad3b3e.jpg";